import { STATUS_PAGE_URL } from "@repo/config/sharedConfig";
import { Button, Flex, Icon, Link, Text } from "@repo/ui";
import { useLocation } from "wouter";
import { Routes } from "../routing";

export function ErrorPage() {
	const [, navigate] = useLocation();

	const handleRetry = () => {
		navigate(Routes.taskList);
		setTimeout(() => {
			window.location.reload();
		}, 100);
	};

	const handleGoBack = () => {
		navigate(Routes.taskList);
	};

	return (
		<Flex column flex gap="lg" align="center" justify="center" grow>
			<Flex
				column
				gap="xl"
				align="center"
				justify="center"
				style={{ width: 400 }}
			>
				<Icon name="AlertCircle" color="red10" size="xl" />
				<Flex column gap="md" align="center">
					<Text size="lg" weight="medium" align="center">
						Connection Error
					</Text>
					<Text align="center" balance>
						We're having trouble connecting to the server. Please try refreshing
						the page or contact support if the problem persists.
					</Text>
					<Link
						href={STATUS_PAGE_URL}
						target="_blank"
						rel="noopener noreferrer"
					>
						Check system status
					</Link>
				</Flex>

				<Flex column gap="md" style={{ width: "100%" }}>
					<Button onPress={handleRetry}>Refresh Page</Button>
					<Button variant="outline" onPress={handleGoBack}>
						Go Back
					</Button>
				</Flex>
			</Flex>
		</Flex>
	);
}
